export default {
  title: '操作日志',
  timeline: '操作时间轴',
  noRecords: '暂无操作记录',
  loadMore: '加载更多',
  related: '关联',
  operation: '操作',
  operator: '操作人',
  operateTime: '操作时间',
  module: '模块',
  detail: '详情',
  create: '新增',
  update: '修改',
  delete: '删除',
  login: '登录',
  logout: '登出',
  lock: '锁定',
  unlock: '解锁',
  match: '匹配',
  import: '导入',
  export: '导出',
  action: {
    BIZ_CREATED: '创建业务委托号',
    BIZ_UPDATED: '修改业务委托号',
    BIZ_UPDATED_NO_CHANGE: '修改业务委托号(未修改)',
    BIZ_DELETED: '删除业务委托号',
    BIZ_CANCEL_REQUESTED: '申请撤单',
    BIZ_CANCEL_APPROVED: '同意撤单',
    BIZ_CANCEL_REJECTED: '拒绝撤单',
    BIZ_CANCELLED: '业务委托号撤单',
    BIZ_COPIED: '复制新建',
    BIZ_SUBMITTED: '提交待订舱',
    BIZ_REVERTED: '撤回至草稿',
    BIZ_VIEWED_BY_OPS: '航线已查看此单',
    BIZ_PARTIAL_UPDATED: '部分修改业务委托号',
    BIZ_CARGO_CHANGED: '货运货物变更',
    BIZ_MATCHED_PO: '匹配产品委托号',
    BIZ_MATCHED_MAWB: '匹配主单号',
    BIZ_UNMATCHED_PO: '取消匹配产品委托号',
    BIZ_WAREHOUSE_BACKFILLED: '回填实际入仓数据',
    BIZ_WAREHOUSE_UPDATED: '修改入仓数据',
    BIZ_WAREHOUSE_HAWB_ADDED: '录入分单号信息',
    BIZ_WAREHOUSE_HAWB_UPDATED: '修改分单号信息',
    BIZ_WAREHOUSE_STATUS_CHANGED: '入仓数据状态变更',
    BIZ_FEE_CONFIRMED: '费用已确认，订单完成',
    BIZ_LOCKED: '锁定',
    BIZ_UNLOCKED: '解锁',
    BIZ_BUBBLE_APPLIED: '应用分泡报价',
    BIZ_BUBBLE_CANCELLED: '取消分泡报价',
    BIZ_BASE_RATE_SET: '设定销售底价',
    BIZ_BASE_RATE_UPDATED: '修改销售底价',
    BIZ_CHANGE_REQUESTED: '申请变更',
    BIZ_CHANGE_APPROVED: '变更审批通过',
    BIZ_CHANGE_REJECTED: '变更审批驳回',
    BIZ_HAWB_CREATED: '入仓建单',
    BIZ_HAWB_CANCELLED: '取消入仓',
    BIZ_COMPLETED: '确认完成',
    BIZ_UNCOMPLETED: '撤销完成',
    BIZ_AUTO_COMPLETED: 'ETD+10天自动完成',
    BIZ_MATCHED: '业务委托号匹配',
    BIZ_DETACHED: '业务委托号取消匹配',
    BIZ_MATCH_STATUS_CHANGED: '变更匹配状态',
    BIZ_DISSOLVED: '因撤舱被清理',
    BIZ_CASCADED_LOCKED: '舱位被锁定',
    BIZ_CASCADED_UNLOCKED: '舱位被解锁',
    BIZ_WAREHOUSE_ADJUSTED: '差异处理调整入仓状态',
    BIZ_POOL_CHANGED: '切换板位',
    BIZ_POOL_RESERVED: '预留板位',
    BIZ_POOL_RELEASED: '释放板位',
    PO_CREATED: '创建产品委托号',
    PO_UPDATED: '修改产品委托号',
    PO_UPDATED_NO_CHANGE: '修改产品委托号(未修改)',
    PO_CASCADED_UPDATED: '业务委托号变更联动更新',
    PO_NUMBER_CHANGED: '修改产品委托号编号',
    BIZ_PRODUCT_ORDER_NO_CHANGED: '关联产品委托号编号变更',
    PO_PRE_SALE: '确定待售',
    PO_LOCKED: '锁定产品委托号',
    PO_UNLOCKED: '解锁产品委托号',
    PO_DISSOLVED: '撤舱产品委托号',
    PO_DELETED: '删除产品委托号',
    PO_ATD_FILLED: '回填ATD',
    PO_ATA_FILLED: '回填ATA，状态变更为已到达',
    PO_ARCHIVED: '所有业务委托号已完成，产品委托号自动归档',
    PO_ROLLBACK_LOCKED: '因业务委托号撤销完成，产品委托号回退为已锁定',
    MAWB_CREATED: '新增主单号',
    MAWB_UPDATED: '修改主单号',
    MAWB_DELETED: '撤销主单号',
    HAWB_CREATED: '入仓建单',
    HAWB_UPDATED: '更新分单号',
    HAWB_CANCELLED: '取消入仓',
    HAWB_AIRLINE_BACKFILLED: '航司数据录入',
    HAWB_DIFF_HANDLED: '差异处理',
    AGREEMENT_WEIGHT_OCCUPIED: '产品委托号关联本协议委托号',
    AGREEMENT_WEIGHT_RELEASED: '产品委托号调整或解除协议关联',
    AGREEMENT_WEIGHT_INCREASED: '产品委托号修改协议板位',
    AGREEMENT_PRODUCT_ORDER_LINKED: '产品委托号关联本协议委托号',
    AGREEMENT_PRODUCT_ORDER_UPDATED: '关联产品委托号已修改',
    AGREEMENT_PRODUCT_ORDER_UNLINKED: '产品委托号解除本协议关联',
    AGREEMENT_CREATED: '创建协议委托号',
    AGREEMENT_UPDATED: '修改协议委托号',
    AGREEMENT_DELETED: '删除协议委托号',
    AGREEMENT_TOGGLED: '生效/失效协议委托号',
    AGREEMENT_STATUS_CHANGED: '协议状态变更',
    FRAMEWORK_AGREEMENT_CREATED: '创建协议',
    FRAMEWORK_AGREEMENT_UPDATED: '修改协议',
    FRAMEWORK_AGREEMENT_TOGGLED: '生效/失效协议',
    FRAMEWORK_AGREEMENT_ORDER_LINKED: '协议委托号加入本协议',
    FRAMEWORK_AGREEMENT_ORDER_UNLINKED: '协议委托号移出本协议',
  },
  field: {
    ratio: '分泡比例',
    rate: '底价',
    currency: '币种',
    oldRate: '原底价',
    reason: '原因',
    fieldName: '字段',
    originalValue: '原值',
    newValue: '新值',
    rejectReason: '驳回原因',
    enteredBy: '录入方式',
    pieces: '件数',
    weight: '重量',
    volume: '体积',
    chargeableWeight: '计费重',
    oldStatus: '原状态',
    newStatus: '新状态',
    hawbNo: '分单号',
    hasHawb: '有无分单',
    oldHasHawb: '原有无分单',
    oldHawbNo: '原分单号',
    issueDate: '签发日期',
    shipper: '发货人',
    consignee: '收货人',
    detailedDescription: '货物描述',
    mawbId: '主单号',
    bizOrderNo: '业务委托号',
    mawbNo: '主单号',
    handling: '处理方式',
    diffStatus: '差异状态',
    changeDesc: '变更内容',
    sourceBizOrderNo: '源委托号',
    airlinePieces: '航司件数',
    airlineWeight: '航司重量',
    airlineVolume: '航司体积',
    atd: 'ATD',
    ata: 'ATA',
    etd: 'ETD',
    affectedBizCount: '影响委托号数',
    oldPieces: '原件数',
    oldWeight: '原重量',
    oldVolume: '原体积',
    oldChargeableWeight: '原计费重',
    agreementNo: '协议编号',
    agreementEntrustNo: '协议委托编号',
    productOrderNo: '产品委托号',
    newWeight: '新占用重量',
    agreementRemaining: '协议剩余重量',
    customerName: '客户名称',
    customerCode: '客户代码',
    customerSource: '客户来源',
    legalEntityRelation: '法人关系',
    bookedPieces: '委托件数',
    bookedWeight: '委托重量',
    bookedVolume: '委托体积',
    sellRate: '卖价单价',
    sellCurrency: '卖价币种',
    salesBaseRate: '销售底价',
    documentFee: '单证费',
    infoTransmissionFee: '信传费',
    manifestFee: '舱单费',
    otherSurcharge: '其他附加费',
    flightNo: '航班号',
    flightDate: '航班日期',
    departure: '始发地',
    destination: '目的地',
    goodsName: '品名',
    goodsNameEn: '英文品名',
    specialHandling: '特殊处理',
    packagingType: '包装类型',
    remark: '备注',
    old_customerName: '原客户名称',
    old_customerCode: '原客户代码',
    old_customerSource: '原客户来源',
    old_legalEntityRelation: '原法人关系',
    old_pieces: '原件数',
    old_weight: '原重量',
    old_volume: '原体积',
    old_bookedPieces: '原委托件数',
    old_bookedWeight: '原委托重量',
    old_bookedVolume: '原委托体积',
    old_sellRate: '原卖价单价',
    old_sellCurrency: '原卖价币种',
    old_salesBaseRate: '原销售底价',
    old_documentFee: '原单证费',
    old_infoTransmissionFee: '原信传费',
    old_manifestFee: '原舱单费',
    old_otherSurcharge: '原其他附加费',
    old_flightNo: '原航班号',
    old_flightDate: '原航班日期',
    old_departure: '原始发地',
    old_destination: '原目的地',
    old_goodsName: '原品名',
    old_goodsNameEn: '原英文品名',
    old_specialHandling: '原特殊处理',
    old_packagingType: '原包装类型',
    old_remark: '原备注',
    noChange: '未修改',
    bubbleRatio: '泡比',
    effectiveSellRate: '卖价单价',
    oldSellRate: '原卖价单价',
    origin: '始发地',
    transportMode: '运输方式',
    productType: '产品类型',
    agreedPalletWeight: '协议板位重量',
    actualPalletWeight: '实际板位重量',
    palletType: '板型',
    agreedPalletCount: '协议板数',
    actualPalletCount: '实际板数',
    trunkRate: '干线单价',
    trunkCostCurrency: '干线币种',
    trunkCostSurcharge: '干线附加费',
    defaultTrunkRate: '默认干线单价',
    old_etd: '原ETD',
    old_eta: '原ETA',
    old_transportMode: '原运输方式',
    old_productType: '原产品类型',
    old_agreedPalletWeight: '原协议板位重量',
    old_actualPalletWeight: '原实际板位重量',
    old_palletType: '原板型',
    old_agreedPalletCount: '原协议板数',
    old_actualPalletCount: '原实际板数',
    old_trunkRate: '原干线单价',
    old_trunkCostCurrency: '原干线币种',
    old_trunkCostSurcharge: '原干线附加费',
    old_defaultTrunkRate: '原默认干线单价',
    old_region: '原区域',
    region: '区域',
    receivable_added: '应收新增',
    receivable_removed: '应收删除',
    receivable_modified: '应收修改',
    receivable_added_detail: '应收新增明细',
    receivable_removed_detail: '应收删除明细',
    receivable_modified_detail: '应收修改明细',
    localCost_added: '应付新增',
    localCost_removed: '应付删除',
    localCost_modified: '应付修改',
    localCost_added_detail: '应付新增明细',
    localCost_removed_detail: '应付删除明细',
    localCost_modified_detail: '应付修改明细',
    uldType: '板位',
    oldUldType: '原板位',
    newUldType: '新板位',
    affectedAgreementOrderCount: '影响协议委托号数',
    sourceAgreementNo: '来源协议',
    oldAgreementNo: '原协议',
    newAgreementNo: '新协议',
    // 业务委托号字段（表单可编辑字段全集）
    status: '状态',
    salesOwner: '销售归属',
    customsType: '报关方式',
    deliveryTerms: '交货条款',
    contactName: '联系人',
    contactPhone: '联系电话',
    contactAddress: '联系地址',
    customerRemark: '客户备注',
    clientReferenceNo: '客户参考号',
    contractType: '合同类型',
    customerType: '客户类型',
    customerLevel: '客户等级',
    cargoType: '货物类型',
    packageType: '包装类型',
    temperatureReq: '温控要求',
    stackDirection: '堆码方向',
    tradeTerms: '贸易条款',
    finalDestination: '最终目的地',
    plannedWorkDate: '计划工作日期',
    requiredDeliveryDate: '要求运到日期',
    flightNoOps: '航班号',
    cargoDescription: '品名',
    specialRemark: '特殊备注',
    paymentMethod: '付款方式',
    paymentTerms: '付款条款',
    taxFlag: '应税/免税',
    hawbPrealertDeclared: '是否申报分单预配',
    shippingTerms: '运输条款',
    serviceItems: '服务项',
    orderCategory: '订单类别',
    shipperName: '发货人名称',
    consigneeName: '收货人名称',
    sellWeight: '计费重量',
    old_status: '原状态',
    old_salesOwner: '原销售归属',
    old_customsType: '原报关方式',
    old_deliveryTerms: '原交货条款',
    old_contactName: '原联系人',
    old_contactPhone: '原联系电话',
    old_contactAddress: '原联系地址',
    old_customerRemark: '原客户备注',
    old_clientReferenceNo: '原客户参考号',
    old_contractType: '原合同类型',
    old_customerType: '原客户类型',
    old_customerLevel: '原客户等级',
    old_cargoType: '原货物类型',
    old_packageType: '原包装类型',
    old_temperatureReq: '原温控要求',
    old_stackDirection: '原堆码方向',
    old_tradeTerms: '原贸易条款',
    old_finalDestination: '原最终目的地',
    old_plannedWorkDate: '原计划工作日期',
    old_requiredDeliveryDate: '原要求运到日期',
    old_flightNoOps: '原航班号',
    old_cargoDescription: '原品名',
    old_specialRemark: '原特殊备注',
    old_paymentMethod: '原付款方式',
    old_paymentTerms: '原付款条款',
    old_taxFlag: '原应税/免税',
    old_hawbPrealertDeclared: '原是否申报分单预配',
    old_shippingTerms: '原运输条款',
    old_serviceItems: '原服务项',
    old_orderCategory: '原订单类别',
    old_shipperName: '原发货人名称',
    old_consigneeName: '原收货人名称',
    old_sellWeight: '原计费重量',
    old_singleWeight: '原单件重量',
    old_singleLength: '原单件长',
    old_singleWidth: '原单件宽',
    old_singleHeight: '原单件高',
    old_sellRate: '原卖价单价',
    // 产品委托号联动更新（业务委托号修改影响产品委托号聚合值）
    causeBizOrderNo: '来源业务委托号',
    causeAction: '变更原因',
    matchedBizCount: '已匹配委托号数',
    pendingWarehouseCount: '待入仓数',
    warehousedCount: '已入仓数',
    mawbCount: '主单数量',
    usedWeight: '已用重量',
    usedGrossWeight: '已用毛重',
    usedVolume: '已用体积',
    standardChargeableWeightTotal: '标准计费重合计',
    totalGrossWeightCapacity: '毛重容量合计',
    totalVolumeCapacity: '体积容量合计',
    remainingSaleableWeight: '剩余可售重量',
    utilizationRate: '舱位利用率',
    salesBaseTotalCost: '销售底价总成本',
    lineProfit: '航线毛利',
    totalRevenue: '总收入',
    mawbPayableTotal: '主单应付合计',
    companyProfit: '公司毛利',
    changeAlert: '变更告警',
    isAlert: '告警',
    old_matchedBizCount: '原已匹配委托号数',
    old_pendingWarehouseCount: '原待入仓数',
    old_warehousedCount: '原已入仓数',
    old_mawbCount: '原主单数量',
    old_usedWeight: '原已用重量',
    old_usedGrossWeight: '原已用毛重',
    old_usedVolume: '原已用体积',
    old_standardChargeableWeightTotal: '原标准计费重合计',
    old_totalGrossWeightCapacity: '原毛重容量合计',
    old_totalVolumeCapacity: '原体积容量合计',
    old_remainingSaleableWeight: '原剩余可售重量',
    old_utilizationRate: '原舱位利用率',
    old_salesBaseTotalCost: '原销售底价总成本',
    old_lineProfit: '原航线毛利',
    old_totalRevenue: '原总收入',
    old_mawbPayableTotal: '原主单应付合计',
    old_companyProfit: '原公司毛利',
    old_changeAlert: '原变更告警',
    old_isAlert: '原告警',
  },
}
